import api from './api';

export function getOrderPaymentData(orderId, orderToken, returnUrl, gaClientId) {
  return dispatch => dispatch(api.post(`orders/by-id/${orderId}/pay`, {returnUrl, gaClientId}, {orderToken}));
}

export function getOrder(orderId, orderToken) {
  return dispatch => dispatch(api.get(`orders/by-id/${orderId}`, {orderToken}));
}

export function getOrderCheckoutFields(orderId, orderToken) {
  return dispatch => dispatch(api.get(`orders/by-id/${orderId}/checkout-fields`, {orderToken}));
}

export function submitOrderCheckoutFields(orderId, orderToken, fields) {
  fields = Object.keys(fields).reduce((acc, key) => {
    const value = fields[key];

    if (Array.isArray(value)) {
      acc[key] = value.reduce((acc, item) => {
        acc[item] = item;
        return acc;
      }, {});
    } else {
      acc[key] = value;
    }

    return acc;
  }, {});

  return dispatch => dispatch(api.post(`orders/by-id/${orderId}/checkout-fields`, fields, {orderToken}));
}



// WEBPACK FOOTER //
// ./ducks/order.js